<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">

        <el-row :span="2" style="margin-top: 30px;">
            <el-select v-model="value"  filterable placeholder="请选择" >
                <el-option
                  v-for="item in options"
                  :key="item.label"
                  :label="item.label"

                  :value="item.value">
                </el-option>

              </el-select>
            <el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
        </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="500"
              label="指令"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.name}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="200"
              label="状态"
               >
               <template slot-scope="scope">
                 <div style="color: #006600;"  v-if="scope.row.status == 1" @click="up(scope.row.id,2)">开</div>
                 <div style="color: red;" v-if="scope.row.status == 2" @click="up(scope.row.id,1)">关</div>

               </template>
            </el-table-column>



            </el-table>
          </template>

        </el-row>






    </el-row>

    </el-container>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {

         list:[],



      }
    },
  directives: {
    },
    created() {

      this.loadList();
      
    },

  methods:{





    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{


      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/qswicth'
      })
      .then(res=>{

        this.list = res.data.list;




      })
      .catch(err=>{

      });
    },

    up(id,t){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/switchUp',
      	params:{
          id:id,
          t:t
        }
      })
      .then(res=>{
        this.loadList();
        this.$message({
        	type: 'success',
        	message: '修改成功！'
        });

      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/qswicth.vue